"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSaleTaxEnum = exports.EventProcessAsEnum = exports.SendQRCodeEnum = exports.EventTaxDeductionEnum = exports.EventTicketDelivery = exports.MultiDayEntryEnum = exports.MultidayEventDates = exports.EventAgeEnum = exports.EventTypeEnum = void 0;
var EventTypeEnum;
(function (EventTypeEnum) {
    EventTypeEnum["GeneralEvent"] = "General Event";
    // BasicEvent = 'Basic Event',
    EventTypeEnum["Concert"] = "Concert";
    // Festival = 'Festival',
    // TEDx = 'TEDx',
    // DinnerParty = 'Dinner Party',
    // Conference = 'Conference',
    // FilmScreening = 'Film Screening',
    // VirtualEvent = 'Virtual Event',
    // StandUpComedy = 'StandUp Comedy',
    // Rodeo = 'Rodeo',
    // ImprovComedy = 'Improv Comedy',
    // Class = 'Class',
    // WorkShop = 'Workshop',
})(EventTypeEnum = exports.EventTypeEnum || (exports.EventTypeEnum = {}));
var EventAgeEnum;
(function (EventAgeEnum) {
    EventAgeEnum["AllAges"] = "All ages welcome";
    EventAgeEnum["EighteenPlus"] = "18+";
    EventAgeEnum["TwentyOnePlus"] = "21+";
})(EventAgeEnum = exports.EventAgeEnum || (exports.EventAgeEnum = {}));
var MultidayEventDates;
(function (MultidayEventDates) {
    MultidayEventDates["DayTwo"] = "2";
    MultidayEventDates["DayThree"] = "3";
    MultidayEventDates["DayFour"] = "4";
    MultidayEventDates["DayFive"] = "5";
    MultidayEventDates["DaySix"] = "6";
    MultidayEventDates["DaySeven"] = "7";
})(MultidayEventDates = exports.MultidayEventDates || (exports.MultidayEventDates = {}));
var MultiDayEntryEnum;
(function (MultiDayEntryEnum) {
    MultiDayEntryEnum["Single"] = "Single";
    MultiDayEntryEnum["Daily"] = "Daily";
})(MultiDayEntryEnum = exports.MultiDayEntryEnum || (exports.MultiDayEntryEnum = {}));
var EventTicketDelivery;
(function (EventTicketDelivery) {
    EventTicketDelivery["Digital"] = "Digital only";
    EventTicketDelivery["Physical"] = "Will-call only";
    EventTicketDelivery["Both"] = "Both digital and will-call";
})(EventTicketDelivery = exports.EventTicketDelivery || (exports.EventTicketDelivery = {}));
var EventTaxDeductionEnum;
(function (EventTaxDeductionEnum) {
    EventTaxDeductionEnum["false"] = "No";
    EventTaxDeductionEnum["true"] = "Yes";
})(EventTaxDeductionEnum = exports.EventTaxDeductionEnum || (exports.EventTaxDeductionEnum = {}));
var SendQRCodeEnum;
(function (SendQRCodeEnum) {
    SendQRCodeEnum["UponOrder"] = "Upon order";
    SendQRCodeEnum["TwoWeeksBefore"] = "Two weeks before show";
    SendQRCodeEnum["DayOfShow"] = "Day of Show";
})(SendQRCodeEnum = exports.SendQRCodeEnum || (exports.SendQRCodeEnum = {}));
var EventProcessAsEnum;
(function (EventProcessAsEnum) {
    EventProcessAsEnum["Paid"] = "Paid";
    EventProcessAsEnum["RSVP"] = "RSVP";
    // Free = 'Free',
})(EventProcessAsEnum = exports.EventProcessAsEnum || (exports.EventProcessAsEnum = {}));
var EventSaleTaxEnum;
(function (EventSaleTaxEnum) {
    EventSaleTaxEnum["SalesTax"] = "Sales tax";
})(EventSaleTaxEnum = exports.EventSaleTaxEnum || (exports.EventSaleTaxEnum = {}));
//# sourceMappingURL=IEvent.js.map